import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { NumberFromInput } from './numberFromInput';

export const TicketBet = types
    .model({
        id: types.number, // internal numbers
        title: types.string,
        isChecked: types.boolean,
        stake: types.maybeNull(NumberFromInput),
        combinationCount: types.maybeNull(types.number),
        unitStake: types.maybeNull(types.number)
    }).actions(self => {

        const setStakeOrValidity = (isValid: boolean, value?: number): void => {
            if (self.stake) {
                self.stake.setValidityAndValue(isValid, value);
            } else {
                self.stake = NumberFromInput.create(<SnapshotOut<typeof NumberFromInput>>{
                    value: value,
                    isValid: isValid
                });
            }
        };

        const toggleSelect = () => {
            self.isChecked = !self.isChecked;
        };

        return {
            setStakeOrValidity,
            toggleSelect
        }
    });

export type ITicketBet = Instance<typeof TicketBet>;